import { type NextRouter } from 'next/router'
import { type TFunction } from 'next-i18next'
import qs from 'query-string'

import { getSrpComposedUrl } from '@/domain/srp/getSrpComposedUrl'
import { CAR_MAKE_VALUES } from '@/features/attributes/constants/attributes'
import {
  addAttributeParamToUrl,
  AttributeType,
} from '@/features/search/utils/vertical-brp/addAttributeParamToUrl'
import { capitalizeString } from '@/utils/string'

type BodyTypeData = {
  imgSrc: string
  label: string
  url: string
}

const { FORD, TOYOTA, HONDA, BMW, NISSAN, CHEVROLET, DODGE, AUDI, HYUNDAI, KIA } = CAR_MAKE_VALUES

export const POPULAR_MAKE_VALUES = [
  FORD,
  TOYOTA,
  HONDA,
  BMW,
  NISSAN,
  CHEVROLET,
  DODGE,
  AUDI,
  HYUNDAI,
  KIA,
]

export const getPopularMakesData = (
  t: TFunction,
  routerQuery: NextRouter['query']
): BodyTypeData[] => {
  const currUrl = getSrpComposedUrl(routerQuery)
  const { query } = qs.parseUrl(currUrl.href)

  return POPULAR_MAKE_VALUES.map((value) => {
    const imgSrc = `/next-assets/images/autos-popular-makes/${value}.png`
    const label = value === 'bmw' ? 'BMW' : capitalizeString(value)
    const seoUrl = addAttributeParamToUrl(AttributeType.MAKE, currUrl.href, [value], t)

    return { value, label, imgSrc, url: qs.stringifyUrl({ url: seoUrl, query }) }
  })
}
